import React, { createRef, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Carousel from 'react-elastic-carousel';
import { useSelector } from 'react-redux';
import { Button, Container, Grid, GridColumn, Icon, Progress, Segment, Table } from 'semantic-ui-react';
import { applyHighlights, deleteHighlights, getSelectedText } from '../../../helpers/general';
import { Calculator, FlexWindow } from '../..';
import Countdown from '../Timers/Countdown';
import { Styles } from '../../../res';
import mouseImage from '../../../res/images/cmatutorial/mouse.jpg';
import navImage from '../../../res/images/cmatutorial/nav.jpg';
import scrollImage from '../../../res/images/cmatutorial/scroll.jpg';
import timerImage from '../../../res/images/cmatutorial/time.jpg';
import flagImage1 from '../../../res/images/cmatutorial/flag.jpg';
import flagImage2 from '../../../res/images/cmatutorial/flag2.jpg';
import filterImage from '../../../res/images/cmatutorial/filters.jpg';
import highlightingImage from '../../../res/images/cmatutorial/highlighting.jpg';


const { noExtraSpaces, carouselExamItemButton } = Styles;

const CmaTutorial = (props) => {

    const { onStartExam, onClose, onGoingExam } = props;
    const carouselRef = createRef();
    const highlightRef = useRef();
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === "ar";
    const { FooterButtonStyle } = styles;
    const [showScrollbar, setShowScrollbar] = useState(false);
    const [showCalculator, setShowCalculator] = useState(false);
    const [pages] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]);
    const [page, setPage] = useState(pages[0]);
    const alphArray = [t('A'), t('B'), t('C'), t('D')];
    const [Q8, setQ8] = useState({
        excluded: null, answer: null, options: [
            { id: 1, text: t("CmaTutorialPage8Text6") },
            { id: 2, text: t("CmaTutorialPage8Text7") },
            { id: 3, text: t("CmaTutorialPage8Text8") },
            { id: 4, text: t("CmaTutorialPage8Text9") },

        ]
    });

    const [Q11, setQ11] = useState({
        excluded: null, answer: null, options: [
            { id: 1, text: t("CmaTutorialPage11Text6") },
            { id: 2, text: t("CmaTutorialPage11Text7") },
            { id: 3, text: t("CmaTutorialPage11Text8") },
            { id: 4, text: t("CmaTutorialPage11Text9") },

        ]
    });

    const [selectedHighlight, setSelectedHighlight] = useState(null);
    const [highlights, setHighlights] = useState([]);

    const user = useSelector(state => state.auth.user);


    useEffect(() => {
        const scrolableElements = document.getElementsByClassName('question-body');
        const scrolableElement = scrolableElements.length > 0 ? scrolableElements[0] : null;

        const checkForScrollbar = () => {
            if (scrolableElement && scrolableElement.scrollHeight > scrolableElement.clientHeight) {
                setShowScrollbar(true);
            }
        };
        const handleScroll = () => {
            (scrolableElement && scrolableElement.scrollTop > 0) && setShowScrollbar(false);
        };
        checkForScrollbar();
        if (scrolableElement)
            scrolableElement.addEventListener('scroll', handleScroll);

        return () => {
            setShowScrollbar(false);
            if (scrolableElement)
                scrolableElement.removeEventListener('scroll', handleScroll);
        };
    }, [page]);

    useEffect(() => {
        setTimeout(() => applyHighlights(highlightRef, highlights, setSelectedHighlight), 0);
    }, [highlights]);

    const selectColor = (q) => {
        if ((q === 8 && Q8.answer) || (q === 11 && Q11.answer)) return '#4c4c4c';
        return '#8CC63F';
    };

    const renderPage = () => {
        switch (page) {
            case 1: return (
                <div className='tw-flex tw-flex-col tw-gap-5'>
                    <div>
                        <p className='tw-font-bold'>{t("CmaTutorialPage1Text1")}</p>
                        <p>{t("CmaTutorialPage1Text2")}</p>
                    </div>

                    <div>
                        <p>{t("CmaTutorialPage1Text3")}</p>
                        <ul className='tw-list-disc tw-px-10 tw-py-2 tw-space-y-2'>
                            <li>{t("CmaTutorialPage1Text4")}</li>
                            <li>{t("CmaTutorialPage1Text5")}</li>
                        </ul>
                    </div>

                    <p>{t("CmaTutorialPage1Text6")}</p>
                    <p>{t("CmaTutorialPage1Text7")}</p>
                    <p>{t("CmaTutorialPage1Text8")}</p>
                    <p>{t("CmaTutorialPage1Text9")}</p>

                </div>
            );
            case 2: return (
                <div className='tw-flex tw-flex-col tw-gap-5'>
                    <p className='tw-font-bold'>{t("CmaTutorialPage2Text1")}</p>
                    <p>{t("CmaTutorialPage2Text2")}</p>
                    <p>{t("CmaTutorialPage2Text3")}</p>
                    <p className='tw-font-bold'>{t("CmaTutorialPage2Text4")}</p>
                </div>
            );
            case 3: return (
                <div className='tw-flex tw-flex-col tw-gap-5'>
                    <p className='tw-font-bold'>{t("CmaTutorialPage3Text1")}</p>
                    <img src={mouseImage} alt='mouse' className='tw-w-16 tw-h-16' />
                    <p>{t("CmaTutorialPage3Text2")}</p>
                    <p className='tw-font-bold'>{t("CmaTutorialPage3Text3")}</p>
                </div>
            );
            case 4: return (
                <div className='tw-flex tw-flex-col tw-gap-5'>
                    <p className='tw-font-bold'>{t("CmaTutorialPage4Text1")}</p>
                    <p>{t("CmaTutorialPage4Text2")}</p>
                    <p>{t("CmaTutorialPage4Text3")}</p>
                    <img alt='nav' src={navImage} className='tw-w-20' />
                    <p>{t("CmaTutorialPage4Text4")}</p>
                    <ul className='tw-list-disc tw-px-10 tw-py-2 tw-space-y-2'>
                        <li>{t("CmaTutorialPage4Text5")}</li>
                        <li>{t("CmaTutorialPage4Text6")}</li>
                        <li>{t("CmaTutorialPage4Text7")}</li>
                        <li>{t("CmaTutorialPage4Text8")}</li>
                    </ul>
                    <p className='tw-font-bold'>{t("CmaTutorialPage4Text9")}</p>
                </div>
            );
            case 5: return (
                <div className='tw-flex tw-flex-col tw-gap-5'>
                    <p className='tw-font-bold'>{t("CmaTutorialPage5Text1")}</p>
                    <p>{t("CmaTutorialPage5Text2")}</p>
                    <img alt="scroll" src={scrollImage} className='tw-w-60' />
                    <p>{t("CmaTutorialPage5Text3")}</p>
                    <p className='tw-font-bold'>{t("CmaTutorialPage5Text4")}</p>
                </div>
            );
            case 6: return (
                <div className='tw-flex tw-flex-col tw-gap-5'>
                    <p className='tw-font-bold'>{t("CmaTutorialPage6Text1")}</p>
                    <p>{t("CmaTutorialPage6Text2")}</p>
                    <img alt='timer' src={timerImage} className='tw-w-60' />
                    <p>{t("CmaTutorialPage6Text3")}</p>
                    <p>{t("CmaTutorialPage6Text4")}</p>
                    <p>{t("CmaTutorialPage6Text5")}</p>
                    <p className='tw-font-bold'>{t("CmaTutorialPage6Text6")}</p>
                </div>
            );
            case 7: return (
                <div className='tw-flex tw-flex-col tw-gap-5'>
                    <p className='tw-font-bold'>{t("CmaTutorialPage7Text1")}</p>
                    <img alt='flag' src={flagImage1} className='tw-w-12' />
                    <p>{t("CmaTutorialPage7Text2")}</p>
                    <p>{t("CmaTutorialPage7Text3")}</p>
                    <p>{t("CmaTutorialPage7Text4")}</p>
                    <img alt='flag' src={flagImage2} className='tw-w-20' />
                    <p className='tw-font-bold'>{t("CmaTutorialPage7Text5")}</p>
                </div>
            );
            case 8: return (
                <div className='tw-flex tw-flex-col tw-gap-5'>
                    <div className='tw-flex tw-flex-col tw-gap-5 tw-bg-PRIMARY_2 tw-p-5'>
                        <p className='tw-font-bold'>{t("CmaTutorialPage8Text1")}</p>
                        <p>{t("CmaTutorialPage8Text2")}</p>
                        <p>{t("CmaTutorialPage8Text3")}</p>
                        <p className='tw-font-bold'>{t("CmaTutorialPage8Text4")}</p>
                        <p>{t("CmaTutorialPage8Text5")}</p>
                    </div>

                    <div>
                        <Segment basic style={{ padding: 0 }} >
                            <Table unstackable basic selectable style={{ borderCollapse: 'collapse' }} >
                                <Table.Body>
                                    {
                                        Q8.options.map((o, indx) => <Table.Row
                                            key={o.id}
                                            onClick={() => setQ8(p => ({ ...p, answer: p.answer ? null : o.id }))}
                                            style={{ backgroundColor: Q8.answer === o.id ? 'orange' : 'white', cursor: 'pointer', border: 'solid 2px rgba(0,0,0,.1)' }}
                                            className='mockExamHoverRow'
                                            onContextMenu={() => setQ8(p => ({ ...p, excluded: p.excluded ? null : o.id }))}
                                        >
                                            <Table.Cell style={{ border: 'none', textDecoration: o.id === Q8.excluded && "line-through" }} collapsing>
                                                {alphArray[indx]}.
                                            </Table.Cell>
                                            <Table.Cell key={`${o.id}`} style={{ textDecoration: o.id === Q8.excluded && "line-through" }} >
                                                {o.text.trim()}
                                            </Table.Cell>
                                        </Table.Row>)
                                    }
                                </Table.Body>
                            </Table>
                        </Segment>
                    </div>
                </div>
            );
            case 9: return (
                <div className='tw-flex tw-flex-col tw-gap-5'>
                    <p className='tw-font-bold'>{t("CmaTutorialPage9Text1")}</p>
                    <div>
                        <Button icon="calculator" content={t("Calculator")} onClick={() => setShowCalculator(true)} />
                    </div>
                    <p>{t("CmaTutorialPage9Text2")}</p>
                    <p>{t("CmaTutorialPage9Text3")}</p>
                    <p className='tw-font-bold'>{t("CmaTutorialPage9Text4")}</p>
                </div>
            );
            case 10: return (
                <div ref={highlightRef}
                    className='tw-flex tw-flex-col tw-gap-5 tw-relative'
                    onMouseDown={() => selectedHighlight && setSelectedHighlight(null)}
                    onMouseUp={() => {
                        selectedHighlight?.selection?.removeAllRanges();
                        const selectionData = getSelectedText(highlightRef);
                        if (selectionData) {
                            setSelectedHighlight({ ...selectionData, type: "SET_HIGHLIGHT" });
                        }
                    }}
                >
                    <p className='tw-font-bold'>{t("CmaTutorialPage10Text1")}</p>
                    <p>{t("CmaTutorialPage10Text2")}</p>
                    <p>{t("CmaTutorialPage10Text3")}</p>
                    <img alt='highlighting' src={highlightingImage} className='tw-w-96' />
                    <p>{t("CmaTutorialPage10Text4")}</p>
                    <p className='tw-font-bold'>{t("CmaTutorialPage10Text5")}</p>

                    {selectedHighlight && <div
                        style={{ position: "fixed", zIndex: 100, top: selectedHighlight?.data?.rect?.y + 30, left: selectedHighlight?.data?.rect?.x + 30 }}
                        onMouseDown={(e) => {
                            e.stopPropagation();
                            if (selectedHighlight.type === "SET_HIGHLIGHT") {
                                selectedHighlight.selection.removeAllRanges();
                                setHighlights([...highlights, selectedHighlight.data]);
                                setSelectedHighlight(null);
                            } else if (selectedHighlight.type === "REMOVE_HIGHLIGHT") {
                                const newHighlights = highlights.filter(h => h.id !== selectedHighlight.data.id);
                                deleteHighlights(highlightRef);
                                setHighlights([...newHighlights]);
                                setSelectedHighlight(null);
                            }
                        }}
                    >
                        <Icon link inverted bordered name='paint brush' color={selectedHighlight.type === "SET_HIGHLIGHT" ? 'green' : 'red'} />
                    </div>}
                </div>
            );
            case 11: return (
                <div className='tw-flex tw-flex-col tw-gap-5'>
                    <div className='tw-flex tw-flex-col tw-gap-5 tw-bg-PRIMARY_2 tw-p-5'>
                        <p className='tw-font-bold'>{t("CmaTutorialPage11Text1")}</p>
                        <p>{t("CmaTutorialPage11Text2")}</p>
                        <p>{t("CmaTutorialPage11Text3")}</p>
                        <p className='tw-font-bold'>{t("CmaTutorialPage11Text4")}</p>
                        <p>{t("CmaTutorialPage11Text5")}</p>
                    </div>

                    <div>
                        <Segment basic style={{ padding: 0 }} >
                            <Table unstackable basic selectable style={{ borderCollapse: 'collapse' }} >
                                <Table.Body>
                                    {
                                        Q11.options.map((o, indx) => <Table.Row
                                            key={o.id}
                                            onClick={() => setQ11(p => ({ ...p, answer: p.answer ? null : o.id }))}
                                            style={{ backgroundColor: Q11.answer === o.id ? 'orange' : 'white', cursor: 'pointer', border: 'solid 2px rgba(0,0,0,.1)' }}
                                            className='mockExamHoverRow'
                                            onContextMenu={() => setQ11(p => ({ ...p, excluded: p.excluded ? null : o.id }))}
                                        >
                                            <Table.Cell style={{ border: 'none', textDecoration: o.id === Q11.excluded && "line-through" }} collapsing>
                                                {alphArray[indx]}.
                                            </Table.Cell>
                                            <Table.Cell key={`${o.id}`} style={{ textDecoration: o.id === Q11.excluded && "line-through" }} >
                                                {o.text.trim()}
                                            </Table.Cell>
                                        </Table.Row>)
                                    }
                                </Table.Body>
                            </Table>
                        </Segment>
                    </div>
                </div>
            );
            case 12: return (
                <div className='tw-flex tw-flex-col tw-gap-5'>
                    <p className='tw-font-bold'>{t("CmaTutorialPage12Text1")}</p>
                    <p>{t("CmaTutorialPage12Text2")} <span><Icon size='big' name='th' /></span>  <span>{t("CmaTutorialPage12Text3")}</span></p>
                    <p>{t("CmaTutorialPage12Text4")}</p>
                    <img alt='filter' src={filterImage} className='tw-w-72' />
                    <p className='tw-font-bold'>{t("CmaTutorialPage12Text5")}</p>
                </div>
            );
            case 13: return (
                <div className='tw-flex tw-flex-col tw-gap-5'>
                    <p className='tw-font-bold'>{t("CmaTutorialPage13Text1")}</p>
                    <p>{t("CmaTutorialPage13Text2")}</p>
                    <p>{t("CmaTutorialPage13Text3")}</p>
                    <p className='tw-font-bold'>{t("CmaTutorialPage13Text4")}</p>
                </div>
            );
            case 14: return (
                <div className='tw-flex tw-flex-col tw-gap-5'>
                    <p className='tw-font-bold'>{t("CmaTutorialPage14Text1")}</p>
                    <p>{t("CmaTutorialPage14Text2")}</p>
                    <p>{t("CmaTutorialPage14Text3")}</p>
                    <p className='tw-font-bold'>{t("CmaTutorialPage14Text4")}</p>
                </div>
            );
            default: return null;
        }
    };

    return (
        <div className='tw-flex tw-flex-col tw-h-screen tw-relative'>

            {/* Header */}
            <div className='tw-bg-[#4c4c4c] tw-px-5 tw-flex tw-flex-row tw-justify-between tw-text-white tw-items-center' >

                <div>
                    <p><span className='tw-font-bold'>{`${t("Page")}: `}</span> <span>{page}</span></p>
                    <p><span className='tw-font-bold'>{`${t("Section")}: `}</span> <span>{t("Introduction")}</span></p>
                </div>

                <div>
                    <Countdown
                        expiryTimestamp={onGoingExam ? onGoingExam.remainTime : (15 * 60 * 1000)}
                        onExpire={onStartExam ? onStartExam : onClose}
                        theme="CMA"
                    />
                </div>

                <div className='tw-w-72'>
                    <Progress label={t('Progress')} precision={1} progress='percent' total={14} value={0} color='green' size='small' inverted style={{ backgroundColor: 'wheat', width: '50%', transform: `translateX(${isArabic === 'ar' ? -50 : 50}%)` }} />
                </div>

                <div >
                    <Button
                        content={t('FinishTest').toUpperCase()}
                        disabled
                    />
                </div>
            </div>
            <div className='tw-bg-[#8CC63F] tw-px-5 tw-flex tw-flex-row tw-justify-between tw-text-white tw-items-center'>
                <p>{t("CMAExamSimulation")}</p>
                <p><span className='tw-font-bold'>{`${t("Candidate")}: `}</span> <span>{`${user.firstName} ${user.lastName}`}</span></p>
            </div>

            {/* Body */}
            <Grid columns='2' style={noExtraSpaces} >
                <GridColumn computer='2' mobile='4' style={noExtraSpaces} textAlign='center'>
                    <Segment basic style={{ minWidth: 110 }}>
                        <Button
                            icon='caret up'
                            style={{ ...carouselExamItemButton, backgroundColor: '#8CC63F' }}
                            disabled={page <= 1}
                            onClick={() => {
                                carouselRef.current.slidePrev();
                                setPage(prev => prev - 1);
                            }} />

                        <Carousel
                            ref={carouselRef}
                            verticalMode
                            focusOnSelect
                            isRTL={isArabic ? true : false}
                            itemPadding={[10, 20]}
                            transitionMs={2000}
                            showArrows={false}
                            itemsToShow={6}
                            itemsToScroll={1}
                            pagination={false}
                            onResize={() => window.ExamNavT = carouselRef.current}
                        >
                            {pages.map((q, index) => <div key={index} className='tw-relative'>
                                {((q === 8 && Q8.answer) || (q === 11 && Q11.answer)) && <div className='tw-absolute tw-border-t-[12px] tw-border-t-white tw-border-e-[12px] tw-border-e-transparent tw-start-0 tw-top-0 tw-w-3 tw-h-3 tw-bg-[#bac4cb] tw-z-10' />}
                                <Button
                                    content={index + 1}
                                    icon={null}
                                    style={{ ...carouselExamItemButton, backgroundColor: selectColor(q), clipPath: page === index + 1 ? isArabic ? 'polygon(25% 0%, 100% 0%, 100% 100%, 25% 100%, 0% 50%)' : 'polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%)' : null }}
                                    onClick={() => setPage(index + 1)}
                                />
                            </div>)}
                        </Carousel>
                        <Button
                            icon='caret down'
                            style={{ ...carouselExamItemButton, backgroundColor: '#8CC63F' }}
                            disabled={page >= pages.length}
                            onClick={() => {
                                carouselRef.current.slideNext();
                                setPage(prev => prev + 1);
                            }} />
                    </Segment>
                </GridColumn>

                <GridColumn computer="14" mobile="12" style={noExtraSpaces}>
                    <Segment style={noExtraSpaces} >
                        <Container style={{ width: '90vw', position: 'relative' }} >

                            {showScrollbar && <div
                                className='tw-text-xl tw-fixed tw-bg-SECONDARY_60 tw-bottom-10 tw-z-50 tw-right-5 tw-p-5 tw-text-white'>
                                {t("PageRequiresScrolling")}
                                <span className="tw-mx-3"><Icon link name='x' size='small' circular style={{ backgroundColor: 'white', color: 'black' }} onClick={() => setShowScrollbar(false)} /></span>
                            </div>}

                            <Segment basic style={{ overflow: 'auto', height: 'calc(100vh - 180px)', paddingBottom: '80px' }} className='question-body'>
                                {renderPage()}
                            </Segment>

                        </Container>


                        {showCalculator && <FlexWindow
                            isVisible={showCalculator}
                            onClose={() => setShowCalculator(false)}
                            title={t("Calculator")}
                        >
                            <Calculator />
                        </FlexWindow>}

                    </Segment>

                </GridColumn>
            </Grid>

            {/* Footer */}
            <Segment inverted basic style={{ backgroundColor: '#4c4c4c', position: 'absolute', left: 0, bottom: 0, width: '100%' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div />


                    <div style={{ textAlign: 'right' }}>
                        <Button disabled={page <= 1} onClick={() => { window?.ExamNavT?.goTo(page - 1); setPage(p => p - 1); }} icon="chevron left" labelPosition='left' content={t('Back').toUpperCase()} style={{ ...FooterButtonStyle, marginLeft: 5, marginRight: 5, }} />
                        <Button disabled={page >= pages.length} onClick={() => { window?.ExamNavT?.goTo(page + 1); setPage(p => p + 1); }} icon="chevron right" labelPosition='right' content={t('Next').toUpperCase()} style={{ ...FooterButtonStyle, marginLeft: 5, marginRight: 5, }} />
                        <Button onClick={onStartExam ? onStartExam : onClose} icon="chevron right" labelPosition='right' content={t(onStartExam ? 'StartTheTest' : 'ContinueTheTest').toUpperCase()} style={{ ...FooterButtonStyle, marginLeft: 5, marginRight: 5 }} />
                    </div>
                </div>
            </Segment>

        </div>
    );
};

const styles = {
    FooterButtonStyle: {
        backgroundColor: '#8CC63F',
        color: 'white'
    }
};

export default CmaTutorial;